export function httpSuccess (status) {
  return status >=200 && status < 400
}
